export default {"src":"/_next/static/media/google_play_icon.c4b3d72f.svg","height":27,"width":25,"blurWidth":0,"blurHeight":0};